import React, { Component, Fragment } from "react";
import joint from "rappid";
import App from "components/DiagramDesigner";
import { Icon, Tooltip, Divider, Button, Input, Form, Select } from "antd";
import { inject, observer } from "mobx-react";

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 4 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 20 }
	}
};

@inject("rootStore")
@observer
class StrategyTab extends Component {	
	layoutGraph = () => {
		this.app.layoutDirectedGraph();
	};
	zoomIn = () => {
		this.app.zoomIn();
	};
	zoomOut = () => {
		this.app.zoomOut();
	};
	downloadGraph = () => {
		const diagram = this.app.exportDiagram();
		// console.log(JSON.stringify(diagram));
	};

	componentDidMount = () => {
		joint.setTheme("modern");
		let app = (this.app = new App.MainView({
			el: "#strategyTabApp",
			viewOnly: true,
			paperContainerEl: "#strategyTabPaperContainer",
			navigatorContainerEl: "#strategyTabNavigatorContainer",
			stencilContainerEl: "#strategyTabStencilContainer"
		}));
		const {
			rootStore: { xwizardStore }
		} = this.props;

		const diagram = JSON.parse(xwizardStore.strategy.strategy);
		this.app.loadDiagram(diagram);
		// const moneySite = this.app.graph.getCell("moneySite");
		// this.app.paperScroller.centerElement(moneySite);
		this.app.paperScroller.zoomToFit({
			padding: 50,
			maxScaleX: 1,
			maxScaleY: 1
		});
	};

	changeStrategy = (strategyId) => {
		const {
			rootStore: { xwizardStore }
		} = this.props;

		const campaignName = xwizardStore.wizard.campaignName;

		let confirmChange = window.confirm("Changing diagram will reset your data. Do you want to continue");
		if (confirmChange) {
			xwizardStore.initCampaign({
				strategyId: strategyId, 
				campaignName: campaignName, 
				wizardName: xwizardStore.wizard.name, 
				wizardId: xwizardStore.wizard.id
			});		
		}		
	}

	render() {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const strategies = xwizardStore.strategies;
		const currentStrategy = xwizardStore.strategy;

		return (
			<Fragment>
				<Form layout="inline">
					<FormItem label="Strategy">
						<Select showSearch filterOption={true} optionFilterProp="name" style={{ width: 200 }} value={currentStrategy.id} onChange={this.changeStrategy}>
							{strategies.map(strategy => {
								return <Option key={strategy.id} value={strategy.id} name={strategy.name}>{strategy.name}</Option>;
							})}
						</Select>
					</FormItem>
				</Form>
				<div id="strategyTabApp" style={{ height: window.screen.height - 100 }}>
					<div className="view-only-diagram-app-header">
						{/* <div className="app-title">
			<h1>Strategy</h1>
		</div> */}
						<Tooltip title="Download Diagram">
							<Button
								type="primary"
								shape="circle"
								onClick={this.downloadGraph}
							>
								<Icon type="download" />
							</Button>
						</Tooltip>
						<Divider type="vertical" />
						<Tooltip title="Auto-layout Diagram">
							<Button type="primary" shape="circle" onClick={this.layoutGraph}>
								<Icon type="layout" />
							</Button>
						</Tooltip>
						<Divider type="vertical" />
						<Tooltip title="Zoom In">
							<Button type="primary" shape="circle" onClick={this.zoomIn}>
								<Icon type="plus-circle-o" />
							</Button>
						</Tooltip>
						<Divider type="vertical" />
						<Tooltip title="Zoom Out">
							<Button type="primary" shape="circle" onClick={this.zoomOut}>
								<Icon type="minus-circle-o" />
							</Button>
						</Tooltip>
					</div>
					<div className="app-body">
						{/* <div className="stencil-container" /> */}
						<div
							className="paper-container"
							id="strategyTabPaperContainer"
							style={{ left: 0 }}
						/>
						{/* <div className="inspector-container" /> */}
						<div
							className="navigator-container"
							id="strategyTabNavigatorContainer"
						/>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default StrategyTab;
